<template>
	<main>
		<HeaderTab :title="$t('global.titre_accounting_archive')" :return_action="'navigationBack'"/>
		<div id="content">
			<div class="container-fluid">
				<div class="row">
					<div class="col-12">
						<div class="box">
							<CustomTable
								id_table="archived_accounting"
								:items="archived_accounting"
								:busy.sync="table_busy"
								primaryKey="accountingplan_id"
								:hide_if_empty="true"
								:hrefsRoutes="config_table_hrefs"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	</main>
</template>

<script type="text/javascript">
import Accounting from "@/mixins/Accounting.js"
import Navigation from "@/mixins/Navigation.js"

export default {
	name: "AccountingArchivedList",
	mixins: [Accounting, Navigation],
	data () {
		return {
			archived_accounting: [],
			table_busy: true,
			config_table_hrefs: {
				'accountingplan_label': {
					routeUniqueName: 'AccountingInformations',
					routeName: 'AccountingInformations',
					params: {
						accountingplan_id: 'accountingplan_id'
					}
				},
				'tiers.tiers_rs': {
					routeUniqueName: 'tiersFiche',
					routeName: 'tiersFiche',
					params: {
						tiers_id: 'tiers.tiers_id'
					}
				}
			},
			events_tab: {
				'TableAction::goToUnarchiveAccounting': (accountingplan_ids) => {
					this.unarchiveAccountingPlan(accountingplan_ids)
					.then(() => {
						this.loadArchivedAccountingList()
					})
				}
			}
		}
	},
	mounted() {
		this.init_component()
	},
	methods: {
		async init_component() {
			this.loadArchivedAccountingList()
		},
		async loadArchivedAccountingList() {
			this.table_busy = true
			this.archived_accounting = await this.loadArchivedAccountingPlans()
			this.table_busy = false
		}
	},
	components: {
		HeaderTab: () => import('@/components/HeaderTab'),
		CustomTable: () => import('GroomyRoot/components/Table/CustomTable')
	}
}
</script>
